import { v4 as uuid } from 'uuid';

// Encodes a string to base64url (RFC 4648): replaces standard base64 chars
// that are not URL-safe (+, /) and strips padding (=).
const toBase64Url = str =>
  btoa(str)
    .replace(/[=]/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');

// Generates a JWT-shaped mock token used when Turnstile validation is disabled
// (REACT_APP_TURNSTILE_DISABLE_VALIDATION=true). Real Turnstile tokens follow
// the same three-segment base64url structure, so this is visually and
// structurally indistinguishable from a real token without decoding it.
// The backend must also have validation disabled to skip token validation.
export const generateMockToken = () => {
  // Standard JWT header indicating RS256 algorithm — matches Turnstile's format.
  const header = toBase64Url(JSON.stringify({ alg: 'RS256', typ: 'JWT' }));

  // Payload with a unique JWT ID (jti) so each call produces a distinct token,
  // plus an issued-at timestamp (iat) in Unix seconds.
  const payload = toBase64Url(
    JSON.stringify({
      iss: 'mock',
      jti: uuid(),
      iat: Math.floor(Date.now() / 1000)
    })
  );

  // Signature segment: two UUIDs concatenated with dashes removed to produce
  // a long alphanumeric string that mimics a real cryptographic signature.
  const signature = (uuid() + uuid()).replace(/-/g, '');

  return `${header}.${payload}.${signature}`;
};
